import { HeadingBase } from 'elements/Heading/styled';

const StyledHeading = HeadingBase.extend`
`;

export default StyledHeading;



// WEBPACK FOOTER //
// ./src/elements/Card/components/Content/styled/StyledHeading.js